import type { ChartStyles } from '@/slices/Chart/types/chart';
import type {
  ChartSliceDefaultPrimaryFirstChartDataItem,
  ChartSliceDefaultPrimarySecondChartDataItem,
  Simplify,
} from '../../../../../../prismicio-types';
import staticStyles from './chartBar.module.scss';

interface ChartBarProps {
  item: Simplify<
    | ChartSliceDefaultPrimaryFirstChartDataItem
    | ChartSliceDefaultPrimarySecondChartDataItem
  >;
  maxValue: number;
  styles: ChartStyles;
  isVisible: boolean;
}

export const ChartBar = ({
  item,
  maxValue,
  styles,
  isVisible,
}: ChartBarProps) => {
  function getHeightPercentage() {
    return (Number(item.value) / maxValue) * 100;
  }

  return (
    <li
      className={`${staticStyles.bar} ${styles.barBackground} ${isVisible ? staticStyles.isVisible : ''}`}
      key={item.axis_label}
      style={{ height: `${isVisible ? getHeightPercentage() : 20}%` }}
    >
      <span className={`${staticStyles.bar_heading} ${styles.color}`}>
        {item.currency}
        {item.value}
        {item.unit}
      </span>
      <div className={`${staticStyles.label} ${styles.heading}`}>
        <span className={staticStyles.indicator}>{item.indicator}</span>
        <span
          className={`${staticStyles.axis_label} ${styles.axisLabel ?? ''}`}
        >
          {item.axis_label}
        </span>
      </div>
    </li>
  );
};
